import * as React from "react";
const CheckIcon = (props) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		style={{
			marginTop: '5px',
			marginLeft: '5px',
		}}
	>
		<path
			d="m2 6 2.475 2.475 5.304-5.303"
			stroke="#B0CAD9"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CheckIcon;
